import { render, staticRenderFns } from "./P-Img.vue?vue&type=template&id=0dd059fb&lang=pug&"
import script from "./P-Img.vue?vue&type=script&lang=js&"
export * from "./P-Img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports